import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/agencies/';
    const paths = {
        endpointSave: config.endpoints.backend + 'agencies/save',
        endpointGetById: config.endpoints.backend + 'agencies/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllPrincipals: config.endpoints.backend + 'principals/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Órgão - Organograma",
        labelTitleEdit: "Editar Órgão - Organograma",
        labelTitleView: 'Visualizar Órgão - Organograma'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        form.fields[2].autoFocus = true;
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'principals',
                    type: 'multiinput',
                    label: 'Dirigentes',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_principal_id',
                            type: 'select',
                            label: 'Dirigente',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllPrincipals,
                                label: 'name',
                                value: 'id',
                                params: {
                                    filter: {
                                        pdc_entity_id: values.pdc_entity_id || profileFilter.pdc_entity_id
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'textarea',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
